import React from 'react';
import { Helmet } from 'react-helmet-async';
import LegalPage, { LegalSection, LegalPlaceholder, LegalNote } from '../../components/legal/LegalPage';
import '../../components/legal/LegalPage.css';

export default function ImpressumPage() {
  return (
    <>
      <Helmet>
        <title>Impressum – Docudi</title>
        <meta name="description" content="Legal disclosure (Impressum) for Docudi, as required by German law (§ 5 TMG)." />
        <meta name="robots" content="noindex" />
      </Helmet>

      <LegalPage title="Impressum" lastUpdated={null}>

        <LegalNote>
          The Impressum is a mandatory legal disclosure required by German law (§ 5 TMG — Telemediengesetz).
          All information below must be accurate and up to date. Incorrect or missing Impressum data can result
          in fines or cease-and-desist letters. Replace every placeholder before going live.
        </LegalNote>

        <LegalSection id="angaben" title="Angaben gemäß § 5 TMG">
          <div className="legal-section__content">
            <p>
              <LegalPlaceholder label="Unternehmensname / Firmenname" /><br />
              <LegalPlaceholder label="Straße und Hausnummer" /><br />
              <LegalPlaceholder label="PLZ Ort" /><br />
              <LegalPlaceholder label="Land (z. B. Deutschland)" />
            </p>
          </div>
        </LegalSection>

        <LegalSection id="vertreten" title="Vertreten durch">
          <div className="legal-section__content">
            <p>
              <LegalPlaceholder label="Vorname Nachname (Geschäftsführer / Inhaber)" />
            </p>
          </div>
        </LegalSection>

        <LegalSection id="kontakt" title="Kontakt">
          <div className="legal-section__content">
            <p>
              Telefon: <LegalPlaceholder label="+49 000 000000" /><br />
              E-Mail: <LegalPlaceholder label="kontakt@example.com" />
            </p>
          </div>
        </LegalSection>

        <LegalSection id="register" title="Registereintrag (falls zutreffend)">
          <div className="legal-section__content">
            <p>
              Eintragung im Handelsregister.<br />
              Registergericht: <LegalPlaceholder label="Amtsgericht [Ort]" /><br />
              Registernummer: <LegalPlaceholder label="HRB XXXXXX" />
            </p>
            <LegalNote>
              Entferne diesen Abschnitt, wenn du kein eingetragenes Unternehmen (GmbH, UG, AG etc.) bist.
              Einzelunternehmer ohne Handelsregistereintrag benötigen diesen Abschnitt nicht.
            </LegalNote>
          </div>
        </LegalSection>

        <LegalSection id="ustid" title="Umsatzsteuer-ID">
          <div className="legal-section__content">
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
              <LegalPlaceholder label="DE000000000" />
            </p>
            <LegalNote>
              Entferne diesen Abschnitt, wenn du umsatzsteuerlich nicht tätig bist oder noch keine USt-ID hast.
            </LegalNote>
          </div>
        </LegalSection>

        <LegalSection id="verantwortlich" title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV">
          <div className="legal-section__content">
            <p>
              <LegalPlaceholder label="Vorname Nachname" /><br />
              <LegalPlaceholder label="Straße und Hausnummer" /><br />
              <LegalPlaceholder label="PLZ Ort" />
            </p>
          </div>
        </LegalSection>

        <LegalSection id="streitschlichtung" title="EU-Streitschlichtung">
          <div className="legal-section__content">
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p>
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
            <p>
              Wir sind <LegalPlaceholder label="bereit / nicht bereit" />, an Streitbeilegungsverfahren vor
              einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>
        </LegalSection>

        <LegalSection id="haftung-inhalte" title="Haftung für Inhalte">
          <div className="legal-section__content">
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach
              den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
              jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
              oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
              Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt
              der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </div>
        </LegalSection>

        <LegalSection id="haftung-links" title="Haftung für Links">
          <div className="legal-section__content">
            <p>
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss
              haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte
              der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </div>
        </LegalSection>

        <LegalSection id="urheberrecht" title="Urheberrecht">
          <div className="legal-section__content">
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
              deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des
              jeweiligen Autors bzw. Erstellers.
            </p>
          </div>
        </LegalSection>

      </LegalPage>
    </>
  );
}
